import { type ParsedUrlQueryInput } from 'node:querystring';
import qs from 'qs';

export const uuidRegExpString = '[A-F0-9]{8}-[A-F0-9]{4}-[45][A-F0-9]{3}-[89AB][A-F0-9]{3}-[A-F0-9]{12}';

export const sanitizeStringForUrl = (str: string): string =>
  str
    .replace(/[^a-zA-Z0-9 ]/g, ' ')
    .trim()
    .replace(/[ ]+/g, '-')
    .toLowerCase();

/**
 * Returns the web hostname if conditions are true, returns false if the preceding conditions fail
 */
const getWebHostname = () => {
  return (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname &&
    window.location.hostname.toLowerCase()
  );
};

/**
 * Returns true if the web hostname is localhost; otherwise false
 */
export const isLocal = () => getWebHostname() === 'localhost';

export const isUnitTest = () => process.env.NODE_ENV === 'test';

const getCurrentQueryString = () => (typeof window !== 'undefined' ? window.location.search.replace('?', '') : '');

// ParsedUrlQueryInput as qs.parse return are actually the same, but TypeScript complains that they mismatch
export const getCurrentQuery = (): ParsedUrlQueryInput =>
  // biome-ignore lint/plugin: qs.ParsedQs permits nested ParsedQs values that ParsedUrlQueryInput doesn't; real query strings never produce that shape
  (qs.parse(getCurrentQueryString()) ?? {}) as ParsedUrlQueryInput;

/**
 * Generates a referral URL for a given user.
 */

export const getPageUrl = () =>
  process.env.NODE_ENV === 'production' ? 'https://app.air.inc' : 'http://localhost:3000';
